import { useCallback, useRef } from 'react'

export const useSelectFirstRadio = () => {
  const hasChecked = useRef(false)
  const radioReference = useCallback((elem: HTMLInputElement | null) => {
    if (elem && !hasChecked.current) {
      hasChecked.current = true
      elem.checked = true // eslint-disable-line no-param-reassign
    }
  }, [])

  return radioReference
}
